"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DanfossAppSwitcher = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_switcher_1 = require("@danfoss/app-switcher");
const app_1 = require("app");
const context_1 = require("../../context");
const typings_1 = require("../../typings");
const DanfossAppSwitcher = ({ label, mobile = false, }) => {
    const { activePopup, setActivePopup, isSilentLogin, secondLevelData: { dipUserProfile, auth0Config: { auth0ClientId, auth0Domain }, }, } = React.useContext(context_1.HeaderContext);
    const onAppSwitcherOpenHandler = () => {
        setActivePopup(typings_1.HeaderPopupEnum.AppSwitcher);
    };
    const onAppSwitcherCloseHandler = () => {
        if (activePopup === typings_1.HeaderPopupEnum.AppSwitcher) {
            setActivePopup(null);
        }
    };
    const language = React.useRef(app_1.UrlService.GetLanguage() || 'en');
    return ((0, jsx_runtime_1.jsx)("div", { className: `appswitcher__wrapper ${mobile ? 'min-w-[44px]' : 'min-w-[70px]'}`, children: (0, jsx_runtime_1.jsx)(app_switcher_1.AppSwitcher, { classes: { dropdownContainer: 'md:translate-y-1.5' }, configValues: {
                clientId: auth0ClientId,
                domain: auth0Domain,
            }, isUserLoggedIn: isSilentLogin && dipUserProfile.isLoggedIn, lang: language.current, callbacks: {
                onOpen: onAppSwitcherOpenHandler,
                onClose: onAppSwitcherCloseHandler,
            }, enableTracking: false }) }));
};
exports.DanfossAppSwitcher = DanfossAppSwitcher;
exports.default = exports.DanfossAppSwitcher;
